import { Icon } from '@chakra-ui/react';

export const RabbitEmail = (props) => (
  <Icon viewBox="0 0 16 16" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M14.6668 4.00002C14.6668 3.26669 14.0668 2.66669 13.3335 2.66669H2.66683C1.9335 2.66669 1.3335 3.26669 1.3335 4.00002V12C1.3335 12.7334 1.9335 13.3334 2.66683 13.3334H13.3335C14.0668 13.3334 14.6668 12.7334 14.6668 12V4.00002ZM13.3335 4.00002L8.00016 7.33335L2.66683 4.00002H13.3335ZM13.3335 12H2.66683V5.33335L8.00016 8.66669L13.3335 5.33335V12Z"
      fill="currentColor"
    />
  </Icon>
);
